// extracted by mini-css-extract-plugin
module.exports = {"merger":"Merger_merger__3N3NY"};